/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

/* tslint:disable:max-classes-per-file */
// tslint:disable:max-classes-per-file
import { Action } from '@ngrx/store';

export const RESET_PLAN = '[Registration] Reset Cart';
export const SET_PLAN = '[Registration] Set Cart Data';
export const SET_RETURN_URL = '[Registration] Set Return Url';
export const SET_PRICE = '[Registration] Set Price';
export const CLEAR_COUPON = '[Registration] Clear Coupon';
export const SET_COUPON = '[Registration] Set Coupon';
export const ADD_ITEMS = '[Registration] Add Items';
export const SET_ITEMS = '[Registration] Set Items';
export const REMOVE_ITEM_AT_INDEX = '[Registration] Remove Item at index';
export const SET_INVITEE = '[Registration] Set Invitee';
export const SET_ITEM_SPORT = '[Registration] Set Item Sport';

export class AddItems implements Action {
  readonly type = ADD_ITEMS;
  constructor(public payload: any[]) {}
}

export class RemoveItemAtIndex implements Action {
  readonly type = REMOVE_ITEM_AT_INDEX;
  constructor(public payload: number) {}
}

export class SetItems implements Action {
  readonly type = SET_ITEMS;
  constructor(public payload: any[]) {}
}

export class SetReturnUrl implements Action {
  readonly type = SET_RETURN_URL;
  constructor(public payload: any) {}
}

export class SetPlan implements Action {
  readonly type = SET_PLAN;
  constructor(public payload: any) {}
}

export class SetPrice implements Action {
  readonly type = SET_PRICE;
  constructor(public payload: any) {}
}

export class ClearCoupon implements Action {
  readonly type = CLEAR_COUPON;
}

export class SetCoupon implements Action {
  readonly type = SET_COUPON;
  constructor(public payload: any) {}
}

export class ResetPlan implements Action {
  readonly type = RESET_PLAN;
}

export class SetInvitee implements Action {
  readonly type = SET_INVITEE;
  constructor(public payload: { index: number; invitee: any }) {}
}

export class SetItemSport implements Action {
  readonly type = SET_ITEM_SPORT;
  constructor(public payload: { index: number; sportId: any }) {}
}

// action types
export type PurchaseAction =
  | AddItems
  | ClearCoupon
  | RemoveItemAtIndex
  | ResetPlan
  | SetCoupon
  | SetInvitee
  | SetItems
  | SetItemSport
  | SetPlan
  | SetPrice
  | SetReturnUrl;
